import { useClipboard } from 'use-clipboard-copy'

import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../i18n/components/T.js'

export const CodeCopyButton = ({ content }: { content: string }) => {
  const clipboard = useClipboard({ copiedTimeout: 1000 })

  return (
    <Button
      size="sm"
      variant="secondary"
      leadingIcon={
        clipboard.copied ? (
          <SvgIcon name="check" />
        ) : (
          <SvgIcon name="duplicate" />
        )
      }
      className="opacity-0 transition-opacity code-copy-button"
      onClick={() => clipboard.copy(content)}
    >
      <T
        id="Generics.CopyTooltip"
        defaultMessage="{copied, select, true {Copied} other {Copy}}"
        values={{ copied: clipboard.copied }}
      />
    </Button>
  )
}
